"use client"

import { useMemo, useState, useEffect } from "react"
import * as Icons from "@/components/icons"

import { useMusicContext } from "@/context/musicContext"
import { resolveRadioStream } from "@/context/music/radio/radioController"

import grainImage from "/image/app/sistema/radio-textura.webp"

export default function RadioPlayerSidebar() {
  const [imagenCargando, setImagenCargando] = useState(true)

  const {
    activeRadio,
    //isPlaying,
    isRadioPlaying,
    playRadioStream,
    stopRadioStream,
    //audioRef,
    currentTrackData,
  } = useMusicContext()

  // =========================
  // RADIO ACTIVA
  // =========================
  
  const radioState = useMemo(() => {
    if (!activeRadio) return null
    return resolveRadioStream(activeRadio as any)
  }, [activeRadio])
  
  const programa = radioState?.program ?? null
  
  //const bgImage = currentTrackData?.trackImg ?? grainImage
  const bgImage = programa?.cover ?? grainImage
    useEffect(() => {
    /* console.log("BG IMAGE UPDATE:", bgImage) */
  }, [bgImage])

  /* const bgImage =
  currentTrackData?.trackImg ||
  programa?.cover ||
  grainImage */
  
  //const isThisRadioPlaying =
  //  isPlaying && !!activeRadio
  const isThisRadioActive =
  isRadioPlaying && !!activeRadio
  
    

  // =========================
  // EMPTY SAFE STATE (SIN ROMPER UI)
  // =========================
  if (!programa) {
  return (
    <div className="
      relative
      flex
      h-full
      min-h-0
      w-full
      flex-col
      items-center
      justify-center
      gap-8
      overflow-hidden
      px-6
      py-6
      text-white 
    ">

      {/* BACKGROUND */}
      <div
        className="
          pointer-events-none
          absolute
          inset-0
          h-[100dvh]
          -z-10
          overflow-hidden
        "
      >

        <div
          className="absolute inset-0 scale-125 blur-3xl"
          style={{
            backgroundImage: "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        <div
          className="absolute inset-0 mix-blend-overlay opacity-80 "
          style={{
            backgroundImage: `url(${grainImage})`,
            backgroundSize: "cover",
          }}
        />

        <div className="absolute inset-0 bg-black/80" />
      </div>

      {/* STATUS */}
      <div className="flex items-center gap-2 rounded-full bg-black px-4 py-2 text-xs font-semibold">
        OFFLINE
        <div className="h-2 w-2 rounded-full bg-gray-500" />
      </div>

      {/* COVER */}
      <div className="w-64 h-64 rounded-2xl bg-white/5 border border-white/10 shadow-xl backdrop-blur-xs" />

      {/* INFO */}
      <div className="flex flex-col items-center gap-2">
        <h2 className="text-lg font-semibold text-white/40">
          — — —
        </h2>

        <p className="text-sm text-white/40">
          --:-- - --:--
        </p>
      </div>

      {/* BUTTON */}
      <button
        disabled
        className="flex h-16 w-16 items-center justify-center rounded-full bg-white/15 text-white shadow-lg backdrop-blur-xs"
      >
        <Icons.Play className="h-5 w-5 opacity-40" />
      </button>

    </div>
  )
}

  // =========================
  // FINALIZADO CHECK
  // =========================
  const isFinalizado = (() => {
    const now = new Date()
    const [endH, endM] = programa.endTime.split(":").map(Number)

    const end = new Date()
    end.setHours(endH, endM, 0, 0)

    return now > end
  })()

  // =========================
  // PLAY / STOP (FIX REAL)
  // =========================
  const handleToggle = () => {
    if (!activeRadio) return

    if (isRadioPlaying) {
      stopRadioStream()
      return
    }

    playRadioStream(activeRadio)
  }

  // =========================
  // UI NORMAL (TU DISEÑO ORIGINAL MEJORADO SOLO EN STABILITY)
  // =========================
  return (
    <div className="
  relative
  flex
  h-full
  min-h-0
  w-full
  flex-col
  items-center
  justify-center
  overflow-hidden
  px-4
  py-4
  text-white
">

      {/* BACKGROUND (FIX: FULL HEIGHT REAL) */}
      <div className="absolute inset-0 -z-10 overflow-hidden">

        <div
          key={bgImage}
          className="absolute inset-0 scale-125 blur-3xl transition-opacity duration-700 contrast-[0.85] saturate-150"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: bgImage ? 1 : 0,
          }}
        />


        <div
          className="h-full absolute inset-0 mix-blend-overlay opacity-80 pointer-events-none"
          style={{
            backgroundImage: `url(${grainImage})`,
            backgroundSize: "cover",
          }}
        />

        <div
          className={`absolute inset-0 transition-colors duration-300 ${
            isFinalizado ? "bg-black/85" : "bg-black/60"
          }`}
        />
      </div>

      {/* STATUS (IGUAL) */}
      <div
        className={`mt-3 flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ${
          isFinalizado ? "bg-red-950/70 text-red-400" : "bg-black text-white"
        }`}
      >
        {isFinalizado ? "FINALIZADO" : "ON AIR"}

        <div
          className={`h-2 w-2 rounded-full ${
            isFinalizado ? "bg-red-500" : "bg-green-400 animate-pulse"
          }`}
        />
      </div>

      {/* COVER (FIX LOADING SAFE) */}
      <div className="
        mt-4
        h-84
        w-84
        max-h-[35vh]
        max-w-[80vw]
        overflow-hidden
        rounded-2xl
        shadow-xl
      ">
        {imagenCargando && (
          <div className="w-full h-full animate-pulse bg-white/10" />
        )}

        <img
          src={programa.cover}
          alt={programa.title}
          onLoad={() => setImagenCargando(false)}
          className={`w-full h-full object-cover transition-all ${
            isFinalizado ? "grayscale" : ""
          }`}
        />
      </div>

      {/* TITLE */}
      <h2 className="mt-4 text-center text-lg font-semibold text-balance">
        {programa.title}
      </h2>

      {/* TIME */}
      <p className="text-sm text-white/60">
        {programa.startTime} - {programa.endTime}
      </p>

      {/* PLAY / STOP (FIXED REAL AUDIO CONTROL) */}
      <button
        onClick={handleToggle}
        disabled={!activeRadio}
        className="mt-5 flex h-16 w-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-xs text-black shadow-lg active:scale-95 hover:scale-105 transition-transform"
      >
        {isThisRadioActive ? (
          <Icons.Stop className="h-5 w-5" />
        ) : (
          <Icons.Play className="h-5 w-5" />
        )}
      </button>
    </div>
  )
}